import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';
import store from './store/store';
import VueApexCharts from 'vue3-apexcharts';

import VueKonva from 'vue-konva';

import axios from '@/config/axiosConfig'; // 해당 axios main.js에서 불러와야 axios config 설정 됩니다.
import i18n from '@/config/i18nConfig'; // 다국어 처리관련 설정 import

import 'element-plus/dist/index.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'ag-grid-community/styles/ag-grid.css'; // Mandatory CSS required by the grid
import 'ag-grid-community/styles/ag-theme-quartz.css'; // Optional Theme applied to the grid

import '../public/assets/css/SUIT.css';
import '../public/assets/css/reset.css';
import '../public/assets/css/crk-components.css';
import '../public/assets/css/crk-style.css';

import ElementPlus from 'element-plus';

import en from 'element-plus/es/locale/lang/en';
import ko from 'element-plus/es/locale/lang/ko';

import { LicenseManager } from 'ag-grid-enterprise';
import { useStore } from 'vuex';
import { getLang } from '@/utils/commonUtils';

LicenseManager.setLicenseKey(`${process.env.VUE_APP_AGGRID_KEY}`); // AG-GRID 라이선스키

const app = createApp(App);
// const store = useStore()

const configLang = () => {
	const lang = getLang();
	switch (lang) {
		case 'ko':
			return {
				locale: ko,
			};
		case 'en':
			return {
				locale: en,
			};
		default:
			return {
				locale: ko, // ElementPlus 언어 한국어로설정
			};
	}
};

// app.config.errorHandler = function (err, vm, info) {
//     // 에러 처리 로직을 작성합니다.
//     console.error('Vue Error:', err, info);
//     alertMsg(err, info)
//     // 예를 들어, 특정 서비스에 로그를 기록하거나 사용자에게 알람을 표시할 수 있습니다.
// };

app.use(router).use(store).use(VueApexCharts).use(VueKonva).use(i18n).use(ElementPlus, configLang()).mount('#app');
